import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'

/**
 * 查询 client roles list
 * @param {*} s
 */
export const queryClientRoleList = (params) => {
    return request({
        url: requestUrl('/role/queryClient'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 删除 client roles
 * @param {*} s
 */
export const deleteClientRoleList = (params) => {
    return request({
        url: requestUrl('/role/delete'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 新增或编辑时查询Role permission
 * @param {*} s
 */
export const queryClientPermission = (params) => {
    return request({
        url: requestUrl('/role/queryClientPermission'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 根据entity 查对应的pbc
 * @param {*} s
 */
export const queryPbcPermission = (params) => {
    return request({
        url: requestUrl('/role/queryPbcPermission'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 根据pbcy 查对应的Topic
 * @param {*} s
 */
export const queryPbcTopicPermission = (params) => {
    return request({
        url: requestUrl('/role/queryPbcTopicPermission'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 新增 client role
 * @param {*} s
 */
export const saveClientRole = (params) => {
    return request({
        url: requestUrl('/role/saveClientRole'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * update client role
 * @param {*} s
 */
export const updateClientRole = (params) => {
    return request({
        url: requestUrl('/role/updateClientRole'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * updata categoryList by selected entity list
 * @param params
 * @returns {AxiosPromise}
 */
export const updateCtategory = (params) => {
    return request({
        url: requestUrl('/siteEntity/queryCategoryPermission'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * query AdminPermission by selected roleId and siteId
 * @param params
 * @returns {AxiosPromise}
 */
export const queryAdminPermission = (params) => {
    return request({
        url: requestUrl('/clientRoleAdminBind/queryAdminPermission'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryUserAdminPermission = (params) => {
    return request({
        url: requestUrl('/clientRoleAdminBind/queryUserAdminPermission'),
        method: 'post',
        data: requestParam(params)
    })
}
